<template>
  <!-- add collection dialog -->
  <Dialog
    :title="
      reportDialogType === ReportObject.MODEL
        ? t('model.info.report_the_work')
        : reportDialogType === ReportObject.COMMENT
        ? t('model.info.report_the_comment')
        : reportDialogType === ReportObject.USER
        ? t('user.report.personal_info_report')
        : t('model.info.report')
    "
    :visible="visible"
    :loading="loading"
    :appendToBody="true"
    @close="close"
    @cancel="close"
  >
    <template #content>
      <el-scrollbar view-class="report-scrollbar">
        <ul>
          <!-- 举报模型或评论 -->
          <template
            v-if="
              reportDialogType === ReportObject.MODEL ||
              reportDialogType === ReportObject.COMMENT
            "
          >
            <li>
              <p class="title-p">
                <a class="red-required">*</a
                >{{ t("model.info.violation_of_laws_and_regulations") }}
              </p>
              <el-radio-group v-model="formData.reasonType">
                <el-radio
                  v-for="item in reportDialogType === ReportObject.MODEL
                    ? optionsList.workRegulations
                    : optionsList.commentRegulations"
                  :value="item.value"
                  :label="item.label"
                  :key="item.key"
                ></el-radio>
              </el-radio-group>
            </li>
            <!-- 模型认领 -->
            <div class="claim" v-if="canClaim">
              <div class="claim-text">{{ t("model.info.claim_text") }}</div>
              <el-button
                class="btn verify-btn"
                @click="handleClaim"
                :loading="claimLoading"
              >
                {{ t("model.info.claim") }}
              </el-button>
            </div>
            <li v-if="reportDialogType === ReportObject.MODEL">
              <p class="title-p">
                <a class="red-required">*</a
                >{{ t("model.info.irregular_work") }}
              </p>
              <el-radio-group v-model="formData.reasonType">
                <el-radio
                  v-for="item in optionsList.work"
                  :value="item.value"
                  :label="item.label"
                  :key="item.key"
                ></el-radio>
              </el-radio-group>
            </li>
            <li>
              <p class="title-p">
                <a class="red-required">*</a
                >{{
                  t("model.info.violation_of_public_order_and_good_customs")
                }}
              </p>
              <el-radio-group v-model="formData.reasonType">
                <el-radio
                  v-for="item in reportDialogType === ReportObject.MODEL
                    ? optionsList.workCustoms
                    : optionsList.commentCustoms"
                  :value="item.value"
                  :label="item.label"
                  :key="item.key"
                ></el-radio>
              </el-radio-group>
            </li>
          </template>
          <!-- 举报用户 -->
          <template v-if="reportDialogType === ReportObject.USER">
            <li>
              <p class="title-p">
                <a class="red-required">*</a
                >{{ t("user.report.report_content") }}
              </p>
              <el-radio-group v-model="formData.reasonType">
                <el-radio
                  v-for="item in optionsList.user"
                  :value="item.value"
                  :label="item.label"
                  :key="item.key"
                ></el-radio>
              </el-radio-group>
            </li>
            <li>
              <p class="title-p">
                <a class="red-required">*</a
                >{{ t("user.report.reason_for_reporting") }}
              </p>
              <el-radio-group v-model="formData.reasonType">
                <el-radio
                  v-for="item in optionsList.userReason"
                  :value="item.value"
                  :label="item.label"
                  :key="item.key"
                ></el-radio>
              </el-radio-group>
            </li>
          </template>
          <li>
            <p class="title-p">
              <a class="red-required">*</a
              >{{ t("model.info.detailed_description") }}
            </p>
            <el-input
              v-model="formData.reportContent"
              type="textarea"
              :maxlength="MAX_DESCRIPTION_LENGTH"
              :show-word-limit="true"
              :autosize="{ minRows: 3, maxRows: 20 }"
              :placeholder="
                t('model.info.please_provide_details_about_the_violation')
              "
            ></el-input>
          </li>
          <li>
            <p class="title-p">
              {{
                `${t("model.info.please_add_images_supports_jpg_png")}(${
                  formData.fileList.length
                }/${MAX_UPLOAD_COUNT})`
              }}
            </p>
            <!-- 重传组件 -->
            <el-upload
              ref="reUploadRef"
              v-model:file-list="replaceList"
              :multiple="false"
              :limit="1"
              :show-file-list="false"
              :auto-upload="false"
              :accept="IMAGE_UPLOAD_ACCEPT_TYPES.JPG_PNG_WEBP_GIF"
              :on-change="replaceChange"
              :on-progress="handleProgress"
              v-show="false"
            />
            <ul class="upload-image-ul">
              <li
                v-for="item in formData.fileList"
                :key="item.fileId"
                style="background-color: #ebeae9"
              >
                <div
                  v-if="!item.fileUrl && !item.preViewUrl"
                  class="uploading-div"
                >
                  <img src="~/assets/images/loading_1.gif" />
                  <p>{{ t("upload.uploading") }}</p>
                </div>
                <div
                  v-else-if="!item.fileUrl && !!item.preViewUrl"
                  class="preView-div"
                >
                  <img :src="item.preViewUrl" />
                  <FileProcess :percentage="item.percentage" />
                </div>
                <template v-else>
                  <Gif v-if="item.fileExt === 'gif'" :src="item.fileUrl" />
                  <img v-else :src="item.fileUrl" :alt="item.fileName" />
                </template>

                <div
                  class="edit-btn"
                  @click="replacePhoto(item)"
                  v-show="!!item.fileUrl"
                >
                  {{ t("upload.replace_image") }}
                </div>

                <div class="close-btn" @click="deletePhoto(item.fileId)">
                  <svg-icon name="icon_white_close" />
                </div>
              </li>
              <li
                style="border: 1px dashed #5416ff"
                v-show="formData.fileList.length < MAX_UPLOAD_COUNT"
              >
                <el-upload
                  ref="uploadRef"
                  class="upload-file-uploader column"
                  v-model:fileList="formData.fileList"
                  :multiple="true"
                  :limit="MAX_UPLOAD_COUNT"
                  :show-file-list="false"
                  :auto-upload="false"
                  :accept="IMAGE_UPLOAD_ACCEPT_TYPES.JPG_PNG_WEBP_GIF"
                  :on-change="uploadChange"
                  :on-progress="handleProgress"
                  :on-exceed="handleExceed"
                >
                  <div class="add-content">
                    <span class="add-icon-span">
                      <svg-icon name="upload-add" />
                    </span>
                  </div>
                </el-upload>
              </li>
            </ul>
          </li>
        </ul>
      </el-scrollbar>
    </template>
    <template #button>
      <div class="footer-button">
        <el-button class="gray-btn" @click="close">{{
          t("common.cancel")
        }}</el-button>
        <el-button
          class="purple-btn"
          :disabled="!canSubmit"
          :loading="loading"
          @click="reportHandle"
          >{{ t("common.submit") }}</el-button
        >
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
const MAX_UPLOAD_COUNT = 6;
const MAX_SINGLE_FILE_SIZE = 100; // 100MB
const MAX_DESCRIPTION_LENGTH = 1000; // 200字

import Gif from "~/components/Gif";
import { ReportObject } from "~/types/report";
import { ReasonType } from "~/types/request/modelRequest.type";
import { IMAGE_UPLOAD_ACCEPT_TYPES } from "~/composables/useUpload";
import { getFileExtension } from "~/utils/file";
import { IFileFormType } from "~/types/upload";
import FileProcess from "~/components/FileProcess";
import { claimModel } from "~/apis/claim";
import { useClaimStore } from "~/store/claim";
import { ClaimType, ClaimErrorCode } from "~/types/claim";

import type { UploadInstance } from "element-plus";

const store = useReportDialogStore();
const claimStore = useClaimStore();
const { visible, formData, loading, reportDialogType } = storeToRefs(store);

const emits = defineEmits(["success", "fail"]);

const { t } = useI18n();

const optionsList = {
  commentRegulations: [
    {
      label: t("model.info.illegal_and_prohibited"),
      value: ReasonType.COMMENT_ILLEGAL_PROHIBITED,
      key: "illegal_and_prohibited",
    },
    {
      label: t("model.info.illegal_external_links"),
      value: ReasonType.COMMENT_ILLEGAL_LINK,
      key: "illegal_external_links",
    },
    {
      label: t("model.info.copyright_infringement_appeal"),
      value: ReasonType.COMMENT_ILLEGAL_INFRINGEMENT_APPEAL,
      key: "copyright_infringement_appeal",
    },
  ],
  workRegulations: [
    {
      label: t("model.info.illegal_and_prohibited"),
      value: ReasonType.WORK_ILLEGAL_PROHIBITED,
      key: "illegal_and_prohibited",
    },
    {
      label: t("model.info.plagiarism_of_work"),
      value: ReasonType.WORK_ILLEGAL_PLAGIARISM_OF_MY_WORK,
      key: "plagiarism_of_work",
    },
    {
      label: t("model.info.illegal_external_links"),
      value: ReasonType.WORK_ILLEGAL_LINK,
      key: "illegal_external_links",
    },
    {
      label: t("model.info.copyright_infringement_appeal"),
      value: ReasonType.WORK_ILLEGAL_INFRINGEMENT_APPEAL,
      key: "copyright_infringement_appeal",
    },
  ],
  work: [
    {
      label: t("model.info.non_original"),
      value: ReasonType.WORK_IRREGULARITY_NOT_ORIGINAL,
      key: "non_original",
    },
    {
      label: t("model.info.adaptation_reposting_error"),
      value: ReasonType.WORK_IRREGULARITY_INCORRECT_REARRANGEMENT,
      key: "adaptation_reposting_error",
    },
    {
      label: t("model.info.other_irregular_activities"),
      value: ReasonType.WORK_IRREGULARITY_OTHER_IRREGULARITIES,
      key: "other_irregular_activities",
    },
  ],
  commentCustoms: [
    {
      label: t("model.info.pornographic_and_vulgar"),
      value: ReasonType.COMMENT_VIOLATION_PORNOGRAPHIC,
      key: "pornographic_and_vulgar",
    },
    {
      label: t("model.info.dangerous_behavior"),
      value: ReasonType.COMMENT_VIOLATION_DANGEROUS_BEHAVIOR,
      key: "dangerous_behavior",
    },
    {
      label: t("model.info.unpleasant_viewing_experience"),
      value: ReasonType.COMMENT_VIOLATION_UNCOMFORTABLE_VIEW,
      key: "unpleasant_viewing_experience",
    },
    {
      label: t("model.info.gory_and_violent"),
      value: ReasonType.COMMENT_VIOLATION_BLOODY_VIOLENCE,
      key: "gory_and_violent",
    },
    {
      label: t("model.info.adolescent_misconduct"),
      value: ReasonType.COMMENT_VIOLATION_NEGATIVE_INFORMATION_FOR_YOUTH,
      key: "adolescent_misconduct",
    },
    {
      label: t("model.info.other"),
      value: ReasonType.COMMENT_VIOLATION_OTHER,
      key: "other",
    },
  ],
  workCustoms: [
    {
      label: t("model.info.pornographic_and_vulgar"),
      value: ReasonType.WORK_VIOLATION_PORNOGRAPHIC,
      key: "pornographic_and_vulgar",
    },
    {
      label: t("model.info.dangerous_behavior"),
      value: ReasonType.WORK_VIOLATION_DANGEROUS_BEHAVIOR,
      key: "dangerous_behavior",
    },
    {
      label: t("model.info.unpleasant_viewing_experience"),
      value: ReasonType.WORK_VIOLATION_UNCOMFORTABLE_VIEW,
      key: "unpleasant_viewing_experience",
    },
    {
      label: t("model.info.gory_and_violent"),
      value: ReasonType.WORK_VIOLATION_BLOODY_VIOLENCE,
      key: "gory_and_violent",
    },
    {
      label: t("model.info.adolescent_misconduct"),
      value: ReasonType.WORK_VIOLATION_NEGATIVE_INFORMATION_FOR_YOUTH,
      key: "adolescent_misconduct",
    },
    {
      label: t("model.info.other"),
      value: ReasonType.WORK_VIOLATION_OTHER,
      key: "other",
    },
  ],
  user: [
    {
      label: t("user.report.avatar_violation"),
      value: ReasonType.MEMBER_INFO_AVATAR_VIOLATION,
      key: "avatar_violation",
    },
    {
      label: t("user.report.nickname_violation"),
      value: ReasonType.MEMBER_INFO_NICKNAME_VIOLATION,
      key: "nickname_violation",
    },
    {
      label: t("user.report.personal_introduction_violation"),
      value: ReasonType.MEMBER_INFO_BIO_VIOLATION,
      key: "personal_introduction_violation",
    },
  ],
  userReason: [
    {
      label: t("model.info.pornographic_and_vulgar"),
      value: ReasonType.MEMBER_BEHAVIOR_PORNOGRAPHIC,
      key: "pornographic_and_vulgar",
    },
    {
      label: t("user.report.false_information"),
      value: ReasonType.MEMBER_BEHAVIOR_FALSE_INFORMATION,
      key: "false_information",
    },
    {
      label: t("user.report.personal_attack"),
      value: ReasonType.MEMBER_BEHAVIOR_PERSONAL_ATTACK,
      key: "personal_attack",
    },
    {
      label: t("model.info.gory_and_violent"),
      value: ReasonType.MEMBER_BEHAVIOR_BLOODY_VIOLENCE,
      key: "gory_and_violent",
    },
    {
      label: t("model.info.illegal_external_links"),
      value: ReasonType.MEMBER_BEHAVIOR_ILLEGAL_LINK,
      key: "illegal_external_links",
    },
    {
      label: t("model.info.other"),
      value: ReasonType.MEMBER_BEHAVIOR_OTHER,
      key: "other",
    },
  ],
};
const canClaim = computed(() => {
  return (
    formData.value.reasonType ===
      ReasonType.WORK_ILLEGAL_PLAGIARISM_OF_MY_WORK &&
    formData.value.modelSourceType == 3
    // &&formData.value.originUrl?.includes("https://makerworld.com")
  );
});
// 提交按钮是否可用
const canSubmit = computed(() => {
  return formData.value.reasonType !== null && formData.value.reportContent;
});
const claimLoading = ref(false);
const handleClaim = () => {
  claimLoading.value = true;
  claimModel(formData.value.modelId as string)
    .then((res: any) => {
      if (res.code == 0) {
        claimStore.setHomepageUrl(res.data.homepageUrl);
        claimStore.setOriginModelId(formData.value.modelId as string);
        claimStore.setVerified(res.data.verified);
        claimStore.setClaimType(ClaimType.VERIFY);
        claimStore.setLinkId(res.data.linkId);
        close();
        setTimeout(() => {
          navigateTo(`/claim/${formData.value.modelId}`, {
            open: { target: "_blank" },
          });
        }, 100);
      } else if (res.code == ClaimErrorCode.THIRD_PARTY_USER_INFO_FAIL) {
        useToast.error(t("claim.third_party_user_info_fail"));
      }
    })
    .finally(() => {
      claimLoading.value = false;
    });
};

const { uploadUrl, httpRequest, getCommonOptions } = useUpload();

// #region upload image;
// @ts-ignore;
const beforeUpload = (file) => {
  const isFileExtSupported =
    IMAGE_UPLOAD_ACCEPT_TYPES.JPG_PNG_WEBP_GIF_TYPES.some(
      (ext: string) =>
        getFileExtension(file).toLowerCase() === ext.toLowerCase()
    );
  if (!isFileExtSupported) {
    useToast.error(t("upload.unsupported_file_format"));
    return false;
  }
  if (file.size > MAX_SINGLE_FILE_SIZE * 1024 * 1024) {
    useToast.error(
      t("upload.uploaded_file_exceeds_upper_limit", {
        value: `${MAX_SINGLE_FILE_SIZE}MB`,
      })
    );
    return false;
  }
  return true;
};

const reUploadRef = ref<UploadInstance>();

const replaceList = ref([]);
const rePlace = () => {
  reUploadRef.value &&
    reUploadRef.value.$el.querySelector('input[type="file"]').click();
};

// 切换图片;
const replaceImageConfig = ref();
const replacePhoto = (config: IFileFormType) => {
  replaceList.value = [];
  replaceImageConfig.value = config;
  rePlace();
};

// 文件数超出提示
const handleExceed: UploadProps["onExceed"] = (): void => {
  useToast.error(t("upload.fileNumsLimit", { num: MAX_UPLOAD_COUNT }));
};

const removeFile = (file: any) => {
  const fileIndex = formData.value.fileList.findIndex(
    (item) => item.uid === file.uid
  );
  !!~fileIndex && formData.value.fileList.splice(fileIndex, 1);
};

const handleUpload = async (file) => {
  const postOptions = getCommonOptions(
    file.raw,
    () => {},
    (process) => {
      handleProgress(process, file, formData.value.fileList);
    }
  );
  const postResponse = await httpRequest(postOptions);
  if (!!postResponse) {
    return {
      fileId: postResponse.fileId,
      fileName: postResponse.name,
      fileSize: postResponse.size,
      fileExt: postResponse.type.replace("image/", ""),
      fileUrl: postResponse.url,
    };
  }
  return false;
};

const clearReplaceImageConfig = () => {
  nextTick(() => {
    replaceImageConfig.value = null;
  });
};

const getPreViewUrl = async (file) => {
  const preViewUrl = await getImagePreViewUrl(file.raw);

  const fileIndex = formData.value.fileList.findIndex(
    (item) => item && item.uid === file.uid
  );
  if (!!~fileIndex) {
    formData.value.fileList[fileIndex] = {
      ...formData.value.fileList[fileIndex],
      ...{ preViewUrl },
    };
  }
};

const replaceChange = async (file) => {
  if (file.status === "success") return false;
  if (!beforeUpload(file)) {
    clearReplaceImageConfig();
    return false;
  }
  await getPreViewUrl(file);
  try {
    const form = await handleUpload(file);
    if (!form) return;
    // 替换;
    if (!!replaceImageConfig.value) {
      const index = formData.value.fileList.findIndex(
        (item) => item.fileId === replaceImageConfig.value.fileId
      );
      if (!!~index) {
        const replaceFileData = {
          ...file,
          ...form,
        };
        formData.value.fileList.splice(index, 1, replaceFileData);
        replaceImageConfig.value = null;
      }
    }
  } catch (error) {
    console.log("uploadChange error :", error);
  }
};

const handleProgress = (event, file, fileListProcess) => {
  nextTick(() => {
    const fileIndex = formData.value.fileList.findIndex(
      (item) => item && item.uid === file.uid
    );
    if (!!~fileIndex) {
      formData.value.fileList[fileIndex] = {
        ...formData.value.fileList[fileIndex],
        ...{ percentage: Number((event.progress * 100).toFixed(2)) },
      };
    }
  });
};

const uploadChange = async (file) => {
  if (file.status === "success") return false;
  if (
    !beforeUpload(file) ||
    formData.value.fileList.length > MAX_UPLOAD_COUNT
  ) {
    removeFile(file);
    return false;
  }
  await getPreViewUrl(file);
  try {
    const form = await handleUpload(file);
    if (!form) return;
    // 新增
    const fileIndex = formData.value.fileList.findIndex(
      (item) => item.uid === file.uid
    );
    if (!!~fileIndex) {
      formData.value.fileList[fileIndex] = {
        ...formData.value.fileList[fileIndex],
        ...form,
      };
    }
  } catch (error) {
    console.log("uploadChange error :", error);
  }
};
// #endregion ;

// 删除图片;
const deletePhoto = (fileId: string) => {
  const index = formData.value.fileList.findIndex(
    (item) => item.fileId === fileId
  );
  if (!!~index) {
    formData.value.fileList.splice(index, 1);
  }
};

const reportHandle = () => {
  store.doReport();
};

const close = () => {
  visible.value = false;
};

watch(
  () => formData.value.reportContent,
  () => {
    nextTick(() => {
      const textareaMaxlengthDoc =
        document.getElementsByClassName("el-input__count");
      if (!textareaMaxlengthDoc || textareaMaxlengthDoc.length === 0) return;
      const origiText = textareaMaxlengthDoc[0].innerText;
      textareaMaxlengthDoc[0].innerText = `${origiText.split("/")[0]} / 1k`;
    });
  }
);
</script>

<style lang="scss" scoped>
@use "./index.scss";
</style>
<style lang="scss">
.report-scrollbar {
  width: 600px !important;
  height: 500px !important;
}
</style>
